import React, { useState, useEffect, useRef } from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";

import HeroBgImg from "../../asset/images/products/1-phase/hero-bg.webp";
import SlideImg1 from "../../asset/images/products/1-phase/slide-1.webp";
import SlideImg2 from "../../asset/images/products/1-phase/slide-2.webp";
import SlideImg3 from "../../asset/images/products/1-phase/slide-3.webp";
import SlideImg4 from "../../asset/images/products/1-phase/slide-4.webp";
import SpecImg   from "../../asset/images/products/1-phase/spec-image.webp";
import FeaturesTabIcon from "../../asset/images/products/1-phase/features-icon.svg";
import SpecTabIcon     from "../../asset/images/products/1-phase/spec-icon.svg";
import DownloadTabIcon from "../../asset/images/products/1-phase/download-icon.svg";
import PdfSvgIcon      from "../../asset/images/products/1-phase/pdf-icon.svg";


const SLIDES = [SlideImg1, SlideImg2, SlideImg3, SlideImg4];
const AUTOPLAY_SPEED = 4500; // ms — change this to control speed

const SALIENT_FEATURES = [
  "Versatile T/R set construction:",
  "Hermetically Sealed type with Corrugated fin;",
  "Conventional with Conservator tank, with & without Breather;",
  "Conventional Sealed type &",
  "Nitrogen-filled tank with radiator",
  "HV transformer, Current-limiting reactor, Rectifier & HF choke are all integrated within the TR tank for ease of maintenance & repairs.",
  "Conforms to IP-65 as per IEC PUB 947-1",
  "HF choke provides excellent surge-protection of rectifier stack diodes",
  "Standard protections include Pressure release valve, Pressure Switch, Oil level gauge, Oil temperature dial thermometer.",
  "Doubly wound, cross-over windings with electrostatic shield between HV & LV winding",
  "HV rectifier stack consists of glass-sealed passive avalanche diodes with controlled avalanche characteristics offer better stability & highest possible immunity to transient travelling waves.",
  "Solenoid Operated Fail-Safe H.V. Grounding Switch.",
  "H.V. Grounding Switch (Oil/Air)",
  "H.V. Isolating Cum Grounding Switch.",
  "Bus-Couplers",
  "Motorized Disconnecting Switch",
  "Motorized Isolator",
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .pd { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .pd-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    background: #111;
  }
  .pd-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .pd-hero-overlay {
    position: absolute;
    inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.82) 0%,
    //   rgba(0,0,0,0.55) 40%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .pd-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .pd-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #fff;
    line-height: 120%;
    margin-bottom: 15px;
  }
  .pd-hero-divider {
    width: 320px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 14px;
  }
  .pd-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 140%;
    max-width: 429px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .pd-breadcrumb {
    padding: 40px 0 0 0;
  }
  .pd-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap:8px;
  }
  .pd-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .pd-bc-item:hover { color: #EB2019; }
  .pd-bc-item.active { color: #202020; }
  .pd-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .pd-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. CONTENT — left text + right slider
  ══════════════════════════════════════════ */
  .pd-section-content {
    padding: 80px 0 120px 0;
  }
  .pd-content-grid {
    display: flex;
    gap: 90px;
    align-items: flex-start;
  }
  .pd-content-left {
    flex: 0 0 594px;
  }
  .pd-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 14px;
    line-height:120%;
  }
  .pd-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .pd-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 140%;
  }
  .pd-para + .pd-para { margin-top: 14px; }

  .pd-slider {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .pd-slider-img-wrap {
    width: 100%;
    height: 500px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    cursor: grab;
    user-select: none;
  }
  .pd-slider-img-wrap:active { cursor: grabbing; }
  .pd-slider-track {
    display: flex;
    height: 100%;
    transition: transform 0.4s ease;
  }
  .pd-slider-track .pd-slider-img {
    min-width: 100%;
    flex-shrink: 0;
  }
  .pd-slider-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .pd-slider-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .pd-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #B8B7B7;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s;
  }
  .pd-dot.active { background: #EB2019; }
  .pd-tabs-section:last-child {
  padding: 00px 0 120px 0;
}

  /* ══════════════════════════════════════════
     DIVIDER
  ══════════════════════════════════════════ */
  .pd-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px  102px 105px 102px;
  }
  .pd-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* ══════════════════════════════════════════
     4. TABS SECTION
  ══════════════════════════════════════════ */
  .pd-tabs-section {
    padding: 0px 0 0px 0;
  }

  /* Spec heading — shown above tab bar only in spec view */
  .pd-spec-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 60px;
  }

  /* Tab bar */
  .pd-tabs-bar {
    display: flex;
    margin-bottom: 42px;
    overflow: visible;
  }

  /* Active tab */
  .pd-tab-active {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
    background: #B91E1A;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    transition: background 0.2s;
  }
  /* triangle pointer */
  .pd-tab-active::after {
    content: '';
    position: absolute;
    bottom: -13px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-top: 13px solid #B91E1A;
    z-index: 2;
  }

  /* Inactive tab */
  .pd-tab-inactive {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 20px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    background: #F1F1F1;
    color: #202020;
    border: none;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
  }
  .pd-tab-inactive:hover { background: #e4e4e4; }

  .pd-tab-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
 .pd-tab-active .pd-tab-icon {
  filter: brightness(0) invert(1);  /* white */
}

.pd-tab-inactive .pd-tab-icon {
  filter: brightness(0);  /* #000000 */
}
  /* ── Salient Features list ── */
  .pd-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .pd-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .pd-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ── Spec image ── */
  .pd-spec-img-wrap {
    display: block;
    max-width: 698px;
  }
  .pd-spec-img {
    width: 100%;
    display: block;
    border-radius: 6px;
  }

  /* ── Download list ── */
  .pd-download-list {
    display: flex;
    flex-direction: column;
    margin-left: 50%;
    border: 1px solid #B8B8B8;
    border-radius: 0px;
    overflow: hidden;
  }
  .pd-download-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    background: #Ffffff;
    border-bottom: 1px solid #B8B8B8;
    text-decoration: none;
    transition: background 0.2s;
  }
  .pd-download-row:last-child { border-bottom: none; }
  .pd-download-row:hover { background: #F6F6F6; }
  .pd-download-label {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #202020;
    padding: 0px 24px;
    border-radius:none;
    
    flex: 1;
  }
  .pd-download-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 60px;
    border-left: 1px solid #B8B8B8;
  }
  .pd-pdf-icon {
    width: 44px;
    height: 44px;
    display: block;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .pd-hero              { height: 300px; }
    .pd-hero-content      { padding: 0 32px; }
    .pd-hero-title        { font-size: 30px; }
    .pd-hero-divider      { width: 260px; }
    .pd-hero-desc         { font-size: 14px; }

    .pd-breadcrumb        { padding: 28px 0 0 0; }
    .pd-breadcrumb-inner  { padding: 0 32px; }
    .pd-inner             { padding: 0 32px; }
    .pd-divider           { padding: 40px 32px; }

    .pd-section-content   { padding: 40px 0px 0px 0px; }
    .pd-content-grid      { flex-direction: column-reverse; gap: 24px; }
    .pd-tabs-bar { margin-bottom: 30px;}
    .pd-red-title { font-size: 24px; margin-bottom: 10px;}
    .pd-subtitle { font-size: 18px; margin-bottom: 10px;}
    .pd-para + .pd-para { margin-top: 10px;}
    .pd-para { font-size: 14px;}
    .pd-content-left      { flex: none; width: 100%; }
    .pd-slider-img-wrap   { height: 280px; }

    .pd-tabs-section      { padding: 40px 0 0px 0; }
    .pd-spec-heading {     font-size: 24px;     margin-bottom: 24px;}
    .pd-tab-active        { font-size: 14px; padding: 16px 12px; }
    .pd-tab-inactive      { font-size: 14px; padding: 16px 12px; }
    .pd-features-list li  { font-size: 14px; }
    .pd-download-list     { margin-left: 0; }
    .pd-download-label { font-size: 18px; padding: 0px 20px;}
    .pd-pdf-icon {     width: 32px; height:32px;}
    .pd-tabs-section:last-child { padding: 00px 0 40px 0;}
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .pd-hero              { height: 400px; }
    .pd-hero-content      { padding: 0 16px; }
    .pd-hero-title        { font-size: 24px; }
    .pd-hero-divider      { width: 100%;     margin-bottom: 15px; }
    .pd-hero-desc         { font-size: 14px; }

    .pd-breadcrumb        { padding: 22px 0 0 0; }
    .pd-breadcrumb-inner  { padding: 0 16px; gap:16px;}
    .pd-bc-item           { font-size: 14px; }
    .pd-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .pd-inner             { padding: 0 16px; }
    .pd-divider           { padding: 0 16px; }
    .pd-tab-icon { width:19px; height:19px;}
    .pd-section-content   { padding: 30px 0; }
    .pd-content-grid      { gap: 30px; }
    .pd-red-title         { font-size: 20px; margin-bottom: 20px;  }
    .pd-subtitle          { font-size: 16px;  margin-bottom: 20px; }
    .pd-para              { font-size: 14px; }
    .pd-slider-img-wrap   { height: 259px; }
    .pd-dot { width:5px; height:5px;}
    

    .pd-tabs-section      { padding: 28px 0 60px 0; }
    .pd-tabs-bar          { flex-direction: row; }
    .pd-tab-active        { flex: none; font-size: 16px; padding: 14px 16px;  width:50%;}
    .pd-tab-active::after { display: none; }
    .pd-tab-inactive       { flex: none; font-size: 16px; padding: 14px 16px; width:50%; }
    .pd-download-label { font-size: 14px;}
        .pd-pdf-icon { width:24px; height:24px;}

    .pd-features-list li  { font-size: 14px; }
    .pd-spec-heading      { font-size: 16px; margin-bottom: 30px; margin-top:60px; }
        .pd-tabs-section:last-child {         padding: 00px 0 60px 0;}
  }
`;

/* Icons */
const FeaturesIcon = () => <img src={FeaturesTabIcon} alt="" className="pd-tab-icon" />;
const SpecIcon     = () => <img src={SpecTabIcon}     alt="" className="pd-tab-icon" />;
const DownloadIcon = () => <img src={DownloadTabIcon} alt="" className="pd-tab-icon" />;

/* ── PDF Icon ── */
const PdfIcon = () => <img src={PdfSvgIcon} alt="PDF" className="pd-pdf-icon" />;

/* ── Reusable Section with switchable main/download tabs ── */
const SectionWithDownload = ({ heading, defaultTab, mainTab, mainContent, downloads }) => {
  const [active, setActive] = React.useState(defaultTab);
  return (
    <section className="pd-tabs-section">
      <div className="pd-inner">
        {heading && <h2 className="pd-spec-heading">{heading}</h2>}
        <div className="pd-tabs-bar">
          <button
            className={active === "main" ? "pd-tab-active" : "pd-tab-inactive"}
            onClick={() => setActive("main")}
          >
            {mainTab.icon} {mainTab.label}
          </button>
          <button
            className={active === "download" ? "pd-tab-active" : "pd-tab-inactive"}
            onClick={() => setActive("download")}
          >
            <DownloadIcon /> Download
          </button>
        </div>
        {active === "main" && mainContent}
        {active === "download" && (
          <div className="pd-download-list">
            {downloads.map((item, i) => (
              <a key={i} href={item.href} className="pd-download-row">
                <span className="pd-download-label">{item.label}</span>
                <span className="pd-download-icon"><PdfIcon /></span>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default function OnePhaseSolutions() {
  const [activeSlide, setActiveSlide] = useState(0);
  const intervalRef = useRef(null);
  const dragStartX   = useRef(null);

  /* ── Autoplay ── */
  const startAutoplay = () => {
    intervalRef.current = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % SLIDES.length);
    }, AUTOPLAY_SPEED);
  };

  const stopAutoplay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, []);

  /* ── Dot click — user interaction ── */
  const goToSlide = (i) => {
    stopAutoplay();
    setActiveSlide(i);
    startAutoplay(); // restart timer after manual interaction
  };

  /* ── Drag / swipe interaction ── */
  const onDragStart = (e) => {
    dragStartX.current = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    stopAutoplay();
  };

  const onDragEnd = (e) => {
    if (dragStartX.current === null) return;
    const endX = e.type === "touchend" ? e.changedTouches[0].clientX : e.clientX;
    const diff  = dragStartX.current - endX;
    if (Math.abs(diff) > 50) {
      setActiveSlide(prev =>
        diff > 0
          ? (prev + 1) % SLIDES.length
          : (prev - 1 + SLIDES.length) % SLIDES.length
      );
    }
    dragStartX.current = null;
    startAutoplay();
  };

  return (
    <div className="pd">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="pd-hero">
        {HeroBgImg && <img className="pd-hero-bg" src={HeroBgImg} alt="" />}
        <div className="pd-hero-overlay" />
        <div className="pd-hero-content">
          <h1 className="pd-hero-title">1-Phase Solutions</h1>
          <hr className="pd-hero-divider" />
          <p className="pd-hero-desc">
            The controlled firing of the Thyristors ensures a low ripple in the output.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="pd-breadcrumb" aria-label="Breadcrumb">
        <div className="pd-breadcrumb-inner">
          <a href="/" className="pd-bc-item">Home</a>
          <span className="pd-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="pd-bc-item">Products</a>
          <span className="pd-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products/esp-power-supplies" className="pd-bc-item">ESP Power Supplies</a>
          <span className="pd-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="pd-bc-item active">1-Phase Solutions</span>
        </div>
      </nav>

      {/* ══ 3. CONTENT ══ */}
      <section className="pd-section-content">
        <div className="pd-inner">
          <div className="pd-content-grid">

            {/* Left */}
            <div className="pd-content-left">
              <h2 className="pd-red-title">1-Phase Solutions</h2>
              <h3 className="pd-subtitle">1-Phase High Voltage T/R Set</h3>
              <p className="pd-para">The ESP power supplies were introduced in 1970s & ever since have a good field-proven performance. They consist primarily of a Thyristor controlled power-circuit, wherein the firing of the Thyristor is controlled to provide a pulse-by-pulse control of the load current.</p>
              <p className="pd-para">The controlled firing of the Thyristors ensures a low ripple in the output.</p>
              <p className="pd-para">Majority of them operate at a fixed frequency of 50 Hz.</p>
              <p className="pd-para">Depending on the customer's availability of power supply, Ador offers the flexibility of providing High  Voltage Transformer Rectifier units in both the Single-phase and Three-phase options.</p>
              <p className="pd-para">Manufacturing range: 30 kV(P) to 200 kV(P) ; 50 mA to 4000 mA</p>
            </div>

            {/* Right — slider */}
            <div className="pd-slider">
              <div
                className="pd-slider-img-wrap"
                onMouseDown={onDragStart}
                onMouseUp={onDragEnd}
                onMouseLeave={() => { dragStartX.current = null; startAutoplay(); }}
                onTouchStart={onDragStart}
                onTouchEnd={onDragEnd}
              >
                <div
                  className="pd-slider-track"
                  style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                >
                  {SLIDES.map((src, i) => (
                    <img
                      key={i}
                      className="pd-slider-img"
                      src={src}
                      alt={`Slide ${i + 1}`}
                      draggable={false}
                    />
                  ))}
                </div>
              </div>
              <div className="pd-slider-dots">
                {SLIDES.map((_, i) => (
                  <button
                    key={i}
                    className={`pd-dot${activeSlide === i ? " active" : ""}`}
                    onClick={() => goToSlide(i)}
                    aria-label={`Slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      

      {/* ══ 4. SALIENT FEATURES SECTION ══ */}
      <SectionWithDownload
        defaultTab="main"
        mainTab={{ icon: <FeaturesIcon />, label: "Salient Features" }}
        mainContent={
          <ul className="pd-features-list">
            {SALIENT_FEATURES.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        }
        downloads={[
          { label: "1-Phase Solutions Brochure", href: "#" },
          { label: "1-Phase Solutions Datasheet", href: "#" },
        ]}
      />

      {/* ══ DIVIDER ══ */}
      <div className="pd-divider"><hr /></div>

      {/* ══ 5. SPECIFICATION SECTION ══ */}
      <SectionWithDownload
        heading="ADOR-CORONA T/R Sets"
        defaultTab="main"
        mainTab={{ icon: <SpecIcon />, label: "Specification" }}
        mainContent={
          <div className="pd-spec-img-wrap">
            <img className="pd-spec-img" src={SpecImg} alt="Specification" />
          </div>
        }
        downloads={[
          { label: "ADOR-CORONA T/R Sets Specification", href: "#" },
          { label: "ADOR-CORONA T/R Sets Datasheet", href: "#" },
        ]}
      />

    </div>
  );
}